<template>
  <one-column-sidebar-left
      back-button-tab-selector="templatebackbutton"
      sub-menu-selector="librarypanel"
      tab-selector="addtemplatetab"
  >
    <div slot="buttonsRight">
      <Button
          :deactivated="!enableSaving"
          class="mb-3 mt-5"
          @click="save">
        <icon v-if="enableSaving" type="save"/>
        <icon v-else type="ban"/>
        {{ $t('SAVE') }}
      </Button>
    </div>

    <div slot="mainContent">
      <h1>
        <icon class="mr-2" size="0.9" type="copy"/>
        {{ $t('createNewTemplate') }}
      </h1>
      <organization-switcher
          class="mb-2"
          @setOrganization="id => { organizationId = id }"
          @setTeam="id => { teamId = id }"
          @unsetTeam="teamId = ''"/>
      <input
          :id="'name'"
          v-model="name"
          :class="['form-text mb-3 mt-3', $v.name.$dirty && $v.name.$error ? 'form-group--error' : '']"
          :placeholder="$t('enternamehere')"
          type="text"
          @input="delayTouch($v.name)"
      >

      <div v-if="$v.name.$dirty && !$v.name.required && $v.name.$error" class="form-error">
        {{ $t('errors.required') }}
      </div>
      <div v-if="$v.name.$dirty && !$v.name.alphaNumSpace" class="form-error">{{ $t('errors.alphaNumSpaceOnly') }}</div>
      <div v-if="$v.name.$dirty && !$v.name.maxLength" class="form-error">
        {{ $t('errors.atMostCharacters', {num: 128}) }}
      </div>
      <div v-if="$v.name.$dirty && !$v.name.minLength" class="form-error">
        {{ $t('errors.atLeastCharacters', {num: 3}) }}
      </div>
      <div v-if="error" class="form-error">{{ $t(error) }}</div>

      <div>
        <div class="vform-label white">
          <b>{{ $t('description') }}</b>
        </div>
        <textarea
            :id="'description'"
            v-model="description"
            :class="['form-text mb-3', $v.description.$dirty && $v.description.$error ? 'form-group--error' : '']"
            :placeholder="$t('enterdeschere')"
            @input="delayTouch($v.description)"
        />
        <div v-if="$v.description.$dirty && !$v.description.maxLength" class="form-error">
          {{ $t('errors.atMostCharacters', {num: 1024}) }}
        </div>
      </div>

      <Button
          :deactivated="!enableSaving"
          class="mb-3 mt-5"
          @click="save">
        <icon v-if="enableSaving" type="save"/>
        <icon v-else type="ban"/>
        {{ $t('SAVE') }}
      </Button>
    </div>
  </one-column-sidebar-left>
</template>

<script>
import Button from "../components/forms/Button";
import OneColumnSidebarLeft from "../layouts/OneColumnSidebarLeft";
import Icon from "../components/Icon";
import {required, minLength, maxLength} from 'vuelidate/lib/validators';
import {alphaNumSpace} from '../customValidators';
import OrganizationSwitcher from "../components/organizations/OrganizationSwitcher";
import VuelidateMixin from "@/components/mixins/VuelidateMixin.js";

export default {
  name: 'TemplateAdd',
  components: {
    OrganizationSwitcher,
    Button,
    OneColumnSidebarLeft,
    Icon,
  },
  mixins: [VuelidateMixin],
  data() {
    return {
      enableSaving: false,
      name: '',
      description: '',
      error: null,
      organizationId: null,
      teamId: '',
    };
  },
  watch: {
    name() {
      this.error = null;
      this.checkSaving();
    },
    description() {
      this.checkSaving();
    },
    '$v.$invalid': function () {
      this.checkSaving();
    },
  },
  validations: {
    name: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(127),
      alphaNumSpace,
    },
    description: {
      maxLength: maxLength(1024),
    },
  },
  methods: {
    checkSaving() {
      this.enableSaving = this.name.length >= 3 && !this.$v.$invalid;
    },
    async save() {
      this.error = null;
      if (!this.enableSaving) return;
      await this.$store.dispatch('createTemplate', {
        name: this.name,
        description: this.description,
        organizationId: this.organizationId,
        teams: this.teamId ? [this.teamId] : [],
        type: 'template',
      }).then(item => {
        this.$router.push(`/library/template/${item.id}/general`);
      }).catch(e => {
        this.error = e;
      });
    },
  },
}
</script>

